import { useContext } from 'react';
import type { GeoObjectCore } from '@search/graphql-typings';

import { GlobalContext } from '../components/GlobalContext';
import { useIsMskMOSPbLO } from './useIsMskMOSPbLO';

const useDeveloperPromoRegion = (regionId?: number) => {
    const { rootRegions } = useContext(GlobalContext);

    const { narrowRegion } = regionId && rootRegions.getById(regionId) || {};
    const narrowRegionId = narrowRegion ? (narrowRegion as GeoObjectCore).id : undefined;

    return useIsMskMOSPbLO(regionId) ? regionId : (narrowRegionId ?? regionId);
};

export default useDeveloperPromoRegion;
